module.exports = __webpack_public_path__ + "static/partnerstack-logo-e6a4e6e5163e6e6542afc9e4f0beed10.svg";